/** Source of the current time. Domain code receives a Clock instead of calling `new Date()`. */
export interface Clock {
  now(): Date;
}

export const systemClock: Clock = {
  now: () => new Date(),
};

/** Deterministic clock for tests and simulations. */
export class ManualClock implements Clock {
  #current: number;

  constructor(start: Date) {
    this.#current = start.getTime();
  }

  now(): Date {
    return new Date(this.#current);
  }

  set(instant: Date): void {
    this.#current = instant.getTime();
  }

  advance(milliseconds: number): void {
    this.#current += milliseconds;
  }
}
